import { createAction } from '../utils/types';
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["PAGE_NAV_START"] = "page::navStart";
    ActionTypes["PAGE_NAV_COMPLETE"] = "page::navComplete";
    ActionTypes["PAGE_NAV_ERROR"] = "page::navError";
})(ActionTypes || (ActionTypes = {}));
export const Actions = {
    pageNavStart: (data) => createAction(ActionTypes.PAGE_NAV_START, data),
    pageNavComplete: (data) => createAction(ActionTypes.PAGE_NAV_COMPLETE, data),
    pageNavError: (data) => createAction(ActionTypes.PAGE_NAV_ERROR, data),
};
//# sourceMappingURL=page.js.map